import { render, staticRenderFns } from "./SlcViewOptionTabs.vue?vue&type=template&id=436479ef&scoped=true&"
import script from "./SlcViewOptionTabs.vue?vue&type=script&lang=ts&"
export * from "./SlcViewOptionTabs.vue?vue&type=script&lang=ts&"
import style0 from "./SlcViewOptionTabs.vue?vue&type=style&index=0&id=436479ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436479ef",
  null
  
)

export default component.exports